const PAGE_LAYOUT_CONSTANTS = Object.freeze({
  titlePrefix: 'CarerWell',
});

export { PAGE_LAYOUT_CONSTANTS };
